/**
 * NCAAF Configuration Constants
 * Centralized configuration for NCAAF dashboard components
 */

// Conference mapping - maps short names/IDs to full API names
export const CONFERENCE_MAP = {
  'sec': 'Southeastern Conference',
  'big10': 'Big Ten',
  'acc': 'Atlantic Coast',
  'big12': 'Big 12',
  'pac12': 'Pacific-12',
  'aac': 'American Athletic',
  'mwc': 'Mountain West',
  'cusa': 'Conference USA',
  'mac': 'Mid-American',
  'sunbelt': 'Sun Belt'
};

// Power 5 conferences
export const POWER_5_CONFERENCES = ['sec', 'big10', 'acc', 'big12', 'pac12'];

// Group of 5 conferences
export const GROUP_OF_5_CONFERENCES = ['aac', 'mwc', 'cusa', 'mac', 'sunbelt'];

// Conference display names (for UI)
export const CONFERENCE_DISPLAY_NAMES = {
  'Southeastern Conference': 'SEC',
  'Big Ten': 'Big Ten',
  'Atlantic Coast': 'ACC',
  'Big 12': 'Big 12',
  'Pacific-12': 'Pac-12',
  'American Athletic': 'AAC',
  'Mountain West': 'Mountain West',
  'Conference USA': 'C-USA',
  'Mid-American': 'MAC',
  'Sun Belt': 'Sun Belt',
  'FBS Independents': 'Independent',
  'FCS Independents': 'FCS Independent'
};

// Conference tiers for grouping
export const CONFERENCE_TIERS = {
  'Southeastern Conference': 'power5',
  'Big Ten': 'power5',
  'Atlantic Coast': 'power5',
  'Big 12': 'power5',
  'Pacific-12': 'power5',
  'American Athletic': 'group5',
  'Mountain West': 'group5',
  'Conference USA': 'group5',
  'Mid-American': 'group5',
  'Sun Belt': 'group5',
  'FBS Independents': 'independent',
  'FCS Independents': 'fcs'
};

// Default season configuration
export const SEASON_CONFIG = {
  startMonth: 8, // August
  endMonth: 1,   // January
  defaultWeek: 1
};

// Ranking thresholds
export const RANKING_CONFIG = {
  top25Threshold: 25,
  topTierThreshold: 5,  // Top 5 teams get special styling
  unrankedValue: 999
};

export default {
  CONFERENCE_MAP,
  POWER_5_CONFERENCES,
  GROUP_OF_5_CONFERENCES,
  CONFERENCE_DISPLAY_NAMES,
  CONFERENCE_TIERS,
  SEASON_CONFIG,
  RANKING_CONFIG
};